import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-employees',
  templateUrl: './new-employees.component.html',
  styleUrls: ['./new-employees.component.scss']
})
export class NewEmployeesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
